import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UserSecurityGroup } from "src/app/features/security-group/interfaces/security-group.interface";
import { Features } from "../enums/features.enum";
import { StorageService } from "../services/storage.service";
import { FeatureAccess } from "../enums/security-feature/access-level.enum";
import { SecurityFeaturePermission } from "src/app/features/security-group/interfaces/security-feature-permission.interface";

export enum SecurityFeature {
  CORPORATION = "corporation",
}

@Injectable({ providedIn: "root" })
export class SecurityFeatureUtility {
  constructor(private storageService: StorageService, private router: Router) {}

  getSecurityFeature(securityFeature: string, validateAccess: boolean = true) {
    const feature = this.storageService
      .getSecurityFeatureData()
      ?.find(
        (c: any) => c.frontendidentifier === securityFeature
      ) as UserSecurityGroup;

    if (validateAccess) {
      this.validateAccess(feature);
    }
    ``;

    return feature;
  }

  getPermissions(
    featureIdentifier: Features,
    validateAccess: boolean = true
  ): SecurityFeaturePermission {
    const feature = this.getSecurityFeature(featureIdentifier, validateAccess);
    const canManage = feature?.featureaccess === FeatureAccess.Manage;
    return {
      canView: canManage || feature?.featureaccess === FeatureAccess.View,
      canManage,
    };
  }

  getPermissionsForChildFromParent(
    parentSecurity: Features,
    childSecurity: Features,
    validateAccess: boolean = true
  ) {
    const feature = this.getSecurityFeature(parentSecurity, validateAccess);
    const childFeature = this.getSecurityFeature(childSecurity, validateAccess);
    const canManage =
      childFeature?.featureaccess === FeatureAccess.Manage &&
      (feature?.featureaccess === FeatureAccess.Manage || feature?.featureaccess === FeatureAccess.View);
    return {
      canView:
        canManage ||
        (childFeature?.featureaccess === FeatureAccess.View && feature?.featureaccess === FeatureAccess.View),
      canManage,
    };
  }

  validateAccess(feature: UserSecurityGroup) {
    if (feature?.featureaccess === FeatureAccess.None) {
      this.router.navigate(['/', 'access-denied']);
    }
  }

  linkAccessible(feature: string) {
    return this.getSecurityFeature(feature, false)?.featureaccess !== FeatureAccess.None;
  }

  canManage(feature: UserSecurityGroup): boolean {
    return feature?.featureaccess === FeatureAccess.Manage;
  }

  canView(feature: UserSecurityGroup): boolean {
    return feature?.featureaccess === FeatureAccess.View;
  }

  canViewFeature(featureIdentifier: Features): boolean {
    const feature = this.getSecurityFeature(featureIdentifier, false);
    return (feature?.featureaccess === FeatureAccess.View || feature?.featureaccess === FeatureAccess.Manage);
  }

  canManageFeature(featureIdentifier: Features): boolean {
    const feature = this.getSecurityFeature(featureIdentifier, false);
    return feature?.featureaccess === FeatureAccess.Manage;
  }
}
